
import React, { useState } from 'react';
import { Header } from '@/components/landing/Header';
import { HeroSection } from '@/components/landing/HeroSection';
import { AIVisualization } from '@/components/landing/AIVisualization';
import { FeaturesGrid } from '@/components/landing/FeaturesGrid';
import { StatsSection } from '@/components/landing/StatsSection';
import { CTASection } from '@/components/landing/CTASection';
import { Footer } from '@/components/landing/Footer';
import { EarlyAccessForm } from '@/components/auth/EarlyAccessForm';

const Landing: React.FC = () => {
  const [showEarlyAccess, setShowEarlyAccess] = useState(false);

  return (
    <div className="relative flex flex-col min-h-screen w-full overflow-x-hidden bg-gray-900">
      {/* Main landing content */}
      <Header />
      <main className={showEarlyAccess ? "pointer-events-none blur-sm flex-grow w-full overflow-x-hidden overflow-y-auto" : "flex-grow w-full overflow-x-hidden overflow-y-auto"}>
        <div className="pt-16">
          <HeroSection onRequestAccess={() => setShowEarlyAccess(true)} />
          <AIVisualization />
          <FeaturesGrid />
          <StatsSection />
          <CTASection onRequestAccess={() => setShowEarlyAccess(true)} />
          <Footer />
        </div>
      </main>

      {/* Early access overlay */}
      {showEarlyAccess && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm">
          <EarlyAccessForm onBack={() => setShowEarlyAccess(false)} />
        </div>
      )}
    </div>
  );
};

export default Landing;
